/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */

import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";

// To extend enum
// declare module "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName" {
//     export enum ResourcesGroupName {
//         GAME_GROUP = "gamegroup"
//     }
// }

// const temp = ResourcesGroupName as any;
// temp["GAME_GROUP"] = "gamegroup";

export class CreepyCarnivalTwoGameAssets {

    public static INTRO_BACKGROUND:string = "introBackground";
    public static REEL_AREA: string = "assets/frame_reel_area";
    public static REEL_AREA_PORTRAIT: string = "assets/frame_reel_area_portrait";
    public static LOGO: string = "assets/logo_frame";
    public static FRAME_BOTTOM: string = "assets/frame_bottom";
    public static MOBILE_LOGO: string = "assets/logo";
    public static MULTIPLIER: string = "assets/multiplier";
    //  public static INTRO_LOGO:string = "introLogo";

    public static NORMAL_REEL_DIVIDER:string = "reelDivider";
    public static NEAR_WIN_REEL_DIVIDER:string = "reelDividerNearWin";

    public static MAIN_GAME_BACKGROUND:string = "main_background";
    public static STAR_SPIN_BACKGROUND:string = "starspin_background";
    public static FREESPIN_GAME_BACKGROUND: string = "fs_background";


    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if(stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "_" + stateName;
    }

    public static getSymbolStateTextures(symbolName:string, stateName:string | null = null):PIXI.Texture[] {
        return GameResources.getTextures(CreepyCarnivalTwoGameAssets.getSymbolStateTexturePath(symbolName, stateName));
    }
    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [
            {
                name : "fonts",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new BitmapFontAsset("numbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset("creepy_font_x1", "fonts/bitmapfonts/creepy_font_x1.fnt"),
                    new BitmapFontAsset("creepy_font_x2", "fonts/bitmapfonts/creepy_font_x2.fnt"),
                    new BitmapFontAsset("creepy_font_x3", "fonts/bitmapfonts/creepy_font_x3.fnt"),
                    new BitmapFontAsset("creepy_font_x5", "fonts/bitmapfonts/creepy_font_x5.fnt"),
                    new BitmapFontAsset("numbersWinCountUp", "fonts/bitmapfonts/NumbersWinCountUp.fnt")
                ]
            },
            {
                name : "intro",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("intro0", "sheets/intro/intro0.json")
                ],
                animations : {
                    "introLogo" : "introLogo"
                }
            },
            {
                name : "introJpeg",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("introJpeg0", "sheets/introJpeg/introJpeg0.json")
                ],
                animations : {
                    "introBackground" : "introBackground"
                }
            }
        ],

        main : [
            {
                name : "main",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json")
                ],
                animations : {
                    "reelDivider" : "ui/reelDividers/div",
                    "reelDividerNearWin" : "ui/reelDividers/div-attention",
                    "cloud": "effects/multi_cloud/cloud_00",
                    "fogfs": "effects/anmbiance/fogfs",
                }
            },
            {
                name : "main1",
                assets : [
                    new TextureAsset("main1", "sheets/main/main1.json")
                ]
            },
            {
                name : "mainJpeg",
                assets : [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json")
                ],
                animations : {
                    "mainBackground": "main_background"
                }
            },
            {
                name : "mainJpeg1",
                assets : [
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json")
                ]
            },
             {
                name : "mainJpeg2",
                assets : [
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json")
                ]
            },
             {
                name : "mainJpeg3",
                assets : [
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json")
                ]
            },
            {
                name : "symbols",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ]
            }
        ]
    };

    public static getSymbolWinStateTexture(symbolName: string): PIXI.Texture[] {
        if (symbolName === "W") {
            return GameResources.getTextures("W/wild_win/wild_win_000");
        } else {
            return GameResources.getTextures(`${symbolName}/${symbolName}_win/${symbolName}_win_000`);
        }
    }

    public static getSymbolAttentionStateTexture(symbolName:string):PIXI.Texture[] {
        if (symbolName === "W") {
            return GameResources.getTextures("W/wild_attention/wild_attention_000");
        } else {
            return GameResources.getTextures("S/S_win/S-");
        }
    }
}
